import React from 'react';
import { first } from 'lodash';

import CurrencySign from 'components/price/CurrencySign.component';
import { useGilt, useTranslation } from 'providers/GILT.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';
import { capitalize } from 'utils/strings/manipulate.util';

import CN from './ClientDepositDetailsRow.module.scss';

const determineDepositStatus = (options) => {
  const { deposit, t } = options;

  return deposit?.depositType === 'used'
    ? deposit?.amount > 0
      ? t('balanceSheet.depositLogTable.rows.voidedCheckout')
      : t('balanceSheet.depositLogTable.rows.redeemedCheckout')
    : deposit?.depositType;
};

const determineStart = (options) => {
  const { deposit, times } = options ?? {};

  if (isFullArray(times)) {
    for (const time of times) {
      const { start_time: start, id } = time ?? {};

      if (id === deposit?.created_for_appointmentId) return start;
      if (id === first(deposit?.used_for_appointmentIds)) return start;
    }
  }

  return void 1;
};

const ClientDepositDetailsRow = ({ deposit, times, showIntentIdColumn }) => {
  const { t } = useTranslation();
  const { formatDate } = useGilt();

  const { source, amount, created_at: createdAt, id: depositId, intent_id: intentId, created_for_appointmentId: appointmentId } = deposit ?? {};

  const appStartTime = determineStart({ times, deposit });
  const depositStatus = determineDepositStatus({ deposit, t });

  const displayStartTime = appStartTime
    ? t('balanceSheet.depositLogTable.rows.appointmentOn', {
        date: formatDate(appStartTime, { hideTime: true, hideWeekday: true }),
      })
    : depositStatus === 'deposited'
      ? t('balanceSheet.depositLogTable.rows.addedCredit')
      : '';

  const displayStatus = capitalize(depositStatus);

  return (
    <tr data-bem="ClientDepositDetailsRow" className={CN.component}>
      <td>{formatDate(createdAt, { hideTime: true, hideWeekday: true })}</td>
      <td>{source}</td>
      <td>
        <CurrencySign value={amount} />
      </td>
      <td>{displayStatus}</td>
      <td>{displayStartTime}</td>
      {fromAnyToBool(showIntentIdColumn) && (
        <td>
          <div className={CN.flex}>
            <div>{t('balanceSheet.depositLogTable.rows.depositId')}</div>
            <div>{depositId}</div>
          </div>
          <div>
            {t('balanceSheet.depositLogTable.rows.intentId')} <div className={CN.intentId}>{intentId}</div>
          </div>
          <div className={CN.flex}>
            <div>{t('balanceSheet.depositLogTable.rows.appointmentId')}</div>
            <div>{appointmentId}</div>
          </div>
        </td>
      )}
    </tr>
  );
};

export default ClientDepositDetailsRow;
